var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowYaxis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 8,
    viewBox: "0 0 93 8",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "red",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3536 4.35355C92.5488 4.15829 92.5488 3.84171 92.3536 3.64645L89.1716 0.464466C88.9763 0.269204 88.6597 0.269204 88.4645 0.464466C88.2692 0.659728 88.2692 0.976311 88.4645 1.17157L91.2929 4L88.4645 6.82843C88.2692 7.02369 88.2692 7.34027 88.4645 7.53553C88.6597 7.7308 88.9763 7.7308 89.1716 7.53553L92.3536 4.35355ZM0 4.5L92 4.5V3.5L0 3.5L0 4.5Z",
    fill: "#353536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowYaxis);
export default __webpack_public_path__ + "static/media/arrow-yaxis.2ad5474be031e63fa4f5e50f0eaa4557.svg";
export { ForwardRef as ReactComponent };